import React, { useState } from 'react';
import './LoadingScreen.css';
import logoIcon from '../assets/icons/logo.svg';

const LoadingScreen = ({ onOpenPlatform }) => {
  const [videoError, setVideoError] = useState(false);

  const handleVideoError = () => {
    console.warn('Failed to load loading video, falling back to image');
    setVideoError(true);
  };

  return (
    <div className="loading-screen">
      {!videoError ? (
        <video
          src="/loading-space.webm"
          className="loading-video"
          autoPlay
          muted
          loop
          playsInline
          onError={handleVideoError}
        />
      ) : (
        <img 
          src="/assets/images/loadscreen.png"
          alt="Loading background"
          className="loading-image"
          onError={(e) => {
            console.warn('Failed to load loading image:', e.target.src);
            e.target.style.display = 'none';
          }}
        />
      )}
      <div className="app-container loading-content">
        <div className="loading-text">
          <h1 className="loading-title">
            <div className="title-line">Открой трейдинг</div>
            <div className="brand-line">
              <img src={logoIcon} alt="D-Space" className="inline-logo" />
              <span>с D-Space</span>
            </div>
          </h1>
          <p className="loading-description">
            Пространство, где ты научишься не угадывать рынок, а понимать его.
          </p>
        </div>
        <button className="loading-cta-btn" onClick={onOpenPlatform}>
          <div className="btn-icon">
            <img src={logoIcon} alt="D-Space"/>
          </div>
          <span>Открыть платформу</span>
        </button>
      </div>
    </div>
  );
};

export default LoadingScreen; 